import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "primereact/button";
import { primaryColor } from "../environment";
import { ErrorBoundaryClass } from "./ErrorBoundaryClass";

const ErrorBoundary = ({ children }: { children: ReactNode }) => {
  const { t } = useTranslation(["common"]);

  const fallback = (
    <div
      className="flex flex-column justify-content-center w-full align-items-center gap-3"
      style={{ minHeight: "100vh", textAlign: "center", padding: "2rem" }}
    >
      <div
        style={{
          color: primaryColor,
          fontSize: "35px",
          fontWeight: 700,
          marginBottom: "1rem",
        }}
      >
        {t("common:errorBoundaryTitle")}
      </div>
      <label style={{ fontSize: "18px", fontWeight: "bold" }}>
        {t("common:errorBoundaryMessage")}
      </label>
      <Button
        className="general-button"
        style={{ marginTop: "1rem" }}
        onClick={() => window.open("/", "_self")}
      >
        {t("common:errorBoundaryButton")}
      </Button>
    </div>
  );

  return <ErrorBoundaryClass fallback={fallback}>{children}</ErrorBoundaryClass>;
};

export default ErrorBoundary;
